import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import loadable from '@loadable/component';
import { fetchOrganizations, fetchOrganization, fetchSeoMeta, fetchSeoLinksBlocks, fetchSeoTextsBlocks, fetchProducts, fetchUpdatedDate } from 'actions';
var HomePage = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-HomePage";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },
  importAsync: function importAsync() {
    return import(
    /* webpackChunkName: "components-HomePage" */
    'components/HomePage');
  },
  requireAsync: function requireAsync(props) {
    var _this = this;

    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("components/HomePage");
    }

    return eval('require.resolve')("components/HomePage");
  }
});
var OrganizationPage = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-OrganizationPage";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },
  importAsync: function importAsync() {
    return import(
    /* webpackChunkName: "components-OrganizationPage" */
    'components/OrganizationPage');
  },
  requireAsync: function requireAsync(props) {
    var _this = this;

    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("components/OrganizationPage");
    }

    return eval('require.resolve')("components/OrganizationPage");
  }
});
var NotFoundPage = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-NotFoundPage";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },
  importAsync: function importAsync() {
    return import(
    /* webpackChunkName: "components-NotFoundPage" */
    'components/NotFoundPage');
  },
  requireAsync: function requireAsync(props) {
    var _this = this;

    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("components/NotFoundPage");
    }

    return eval('require.resolve')("components/NotFoundPage");
  }
});
var routes = [{
  id: 'homePage',
  path: ['/:clientType(it)?/:page(fop)?/'],
  exact: true,
  strict: true,
  component: HomePage,
  props: {
    loadData: function () {
      var _loadData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, props) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", Promise.all([dispatch(fetchUpdatedDate(props)), dispatch(fetchProducts(props)), dispatch(fetchOrganizations(props)), dispatch(fetchSeoMeta(props)), dispatch(fetchSeoLinksBlocks(props)), dispatch(fetchSeoTextsBlocks(props))]));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function loadData(_x, _x2) {
        return _loadData.apply(this, arguments);
      }

      return loadData;
    }()
  }
}, {
  id: 'organizationPage',
  path: ['/:organizationSlug([a-z0-9_-]{1,})/'],
  exact: true,
  strict: true,
  component: OrganizationPage,
  props: {
    loadData: function () {
      var _loadData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, props) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", Promise.all([Promise.all([dispatch(fetchOrganization(props))]).then(function () {
                  return dispatch(fetchProducts(props));
                })].concat([dispatch(fetchSeoMeta(props)), dispatch(fetchSeoLinksBlocks(props)), dispatch(fetchSeoTextsBlocks(props))])));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function loadData(_x3, _x4) {
        return _loadData2.apply(this, arguments);
      }

      return loadData;
    }()
  }
}, {
  id: 'notFoundPage',
  props: {},
  component: NotFoundPage
}];
export default routes;